module.exports = __webpack_public_path__ + "img/shangwuguangchang.90fdddf5.jpg";